import type { CardResult, TeamId } from '../shared/index.js';

export const s = {
  name: 'Tabu',
  pitch: 'Yasaklı kelimeleri söylemeden takımına anlat',
  team: { a: 'Yeşil takım', b: 'Mor takım' } satisfies Record<TeamId, string>,
  settings: {
    teams: 'Takımlar',
    teamsHint: 'Bir oyuncuya dokunarak takımını değiştir. Takımı seçilmeyenler başlarken dağıtılır.',
    unassigned: 'Takımsız',
    shuffle: 'Karıştır',
    empty: 'Henüz kimse yok',
    categories: 'Kategoriler',
    adultHint: '+18 kategoriler açık cinsel içerik içerir; yalnızca yetişkinler içindir.',
    seconds: 'Tur süresi',
    sec: (n: number) => `${n} sn`,
    passes: 'Pas hakkı',
    unlimited: 'Sınırsız',
    turns: 'Takım başına anlatma',
    turnsHint: (n: number) => (n === 0 ? 'Oda sahibi bitirene kadar sürer.' : `Toplam ${n * 2} tur.`),
    penalty: 'Tabu cezası',
    penaltyHint: 'Yasaklı kelime söylenirse anlatan takımdan 1 puan düşer.',
    on: 'Açık',
    off: 'Kapalı',
    readOnly: 'Ayarları oda sahibi seçer.',
    addCard: 'Kart ekle',
    addCardHint: 'Eklediğin kart “Arkadaş kartları” kategorisine girer.',
    word: 'Anlatılacak kelime',
    taboo: (i: number) => `Yasaklı ${i}`,
    save: 'Kartı ekle',
    saving: 'Ekleniyor…',
    saved: (w: string) => `“${w}” eklendi.`,
    needTwo: 'Her takımda en az 2 kişi olmalı.',
  },
  play: {
    turn: (n: number, total: number | null) => (total ? `Tur ${Math.min(n + 1, total)}/${total}` : `Tur ${n + 1}`),
    pill: (turn: string) => `Tabu · ${turn}`,
    headNarrator: (nick: string) => `${nick} anlatıyor · sen`,
    headWatcher: (nick: string) => `${nick} anlatıyor · kartı sen de görüyorsun`,
    headSpectator: (nick: string) => `${nick} anlatıyor`,
    guessedLabel: 'BU TURDA BİLİNEN',
    nextLabel: 'SIRADAKİ ANLATICI',
    lastLabel: 'Son tur',
    teamsLabel: 'Takımlar',
    settingsTitle: 'Oyun ayarları',
    timeLeft: (n: number) => `${n} saniye kaldı`,
    you: 'sen',
    narrating: 'anlatıyor',
    next: 'Sıradaki anlatıcı',
    startMine: 'Anlatmaya başla',
    startMineHint: 'Başlayınca kartı yalnızca sen ve rakip takım göreceksiniz.',
    startForThem: (nick: string) => `${nick} yerine başlat`,
    skipNarrator: 'Anlatıcıyı atla',
    waitNarrator: (nick: string) => `${nick} turu başlatınca süre işlemeye başlayacak.`,
    correct: 'Doğru',
    pass: (left: number | null) => (left === null ? 'Pas' : `Pas (${left})`),
    undo: 'Geri al',
    taboo: 'Tabu!',
    tabooHint: 'Anlatıcı yasaklı kelimelerden birini (ya da anlatılan kelimeyi) söylerse bas.',
    guess: (nick: string) => `${nick} anlatıyor. Tahmin et!`,
    guessHint: 'Kartı göremezsin; anlatıcıyı dinle ve cevabı yüksek sesle söyle.',
    spectator: 'Bu tur izliyorsun.',
    narratorNote: 'Takımın tahmin edince “Doğru”ya bas.',
    stats: { correct: 'Doğru', pass: 'Pas', taboo: 'Tabu' } satisfies Record<CardResult, string>,
    flash: { correct: 'Doğru! +1', pass: 'Pas', taboo: 'TABU!' } satisfies Record<CardResult, string>,
    lastTurn: (team: string, pts: number) => `${team} bu turda ${pts > 0 ? '+' : ''}${pts}`,
    noCards: 'Bu turda kart geçmedi.',
    seconds: 'sn',
  },
  podium: {
    title: 'OYUN BİTTİ',
    winner: (team: string) => `${team} kazandı!`,
    draw: 'Berabere!',
    won: 'kazandı!',
    back: 'Lobiye dönülüyor…',
  },
  howto: {
    title: 'Nasıl oynanır',
    steps: [
      ['Takımlar', 'İki takım sırayla anlatır. Her turda anlatan takımdan bir kişi anlatıcı olur.'],
      ['Anlat', 'Anlatıcı kartı görür; yasaklı 5 kelimeyi ve kelimenin kendisini söylemeden takımına anlatır.'],
      ['Kontrol', 'Rakip takım da kartı görür. Yasaklı kelime söylenirse “Tabu!”ya basar.'],
      ['Puan', 'Her doğru +1 puan. Tabu cezası açıksa her tabu −1. Pas hakkı sınırlıdır.'],
    ] as [string, string][],
  },
};
